/* Metalika Studio - collection page enhancements. Added 30 Aug 2026.
 *
 * Progressive enhancement only. Every function is wrapped so a failure in one
 * cannot stop the others, and none of them removes anything the theme rendered
 * except the mis-announced "Sold out" label on in-stock cards, which is a bug.
 *
 * Data comes from window.MTK_COL, emitted by snippets/metalika-collection.liquid
 * and computed from the collection's own storefront filters, so counts are the
 * real published in-stock figures rather than anything typed in.
 */
(function () {
  'use strict';
  var D = window.MTK_COL;
  if (!D) return;
  var doc = document;

  function safe(fn) { try { fn(); } catch (e) { /* never break the page */ } }

  /* The theme renders the grid into #items-grid on this template and
   * #product-grid on others. Resolve it rather than assuming either. */
  function gridEl() {
    return doc.getElementById('items-grid') || doc.getElementById('product-grid') ||
      (function () { var it = doc.querySelector('.grid-item'); return it ? it.parentElement : null; })();
  }

  /* ------------------------------------------------------- breadcrumb (P3) */
  function crumb() {
    if (doc.querySelector('.mtk-crumb')) return;
    var host = doc.querySelector('.x-section-collection-banner');
    if (!host) return;
    var nav = doc.createElement('nav');
    nav.className = 'mtk-crumb';
    nav.setAttribute('aria-label', 'Breadcrumb');
    var ol = doc.createElement('ol');
    var parts = [['Home', '/'], ['Shop', '/collections/all'], [D.title || '', null]];
    parts.forEach(function (pt) {
      if (!pt[0]) return;
      var li = doc.createElement('li');
      if (pt[1]) {
        var a = doc.createElement('a'); a.href = pt[1]; a.textContent = pt[0]; li.appendChild(a);
      } else {
        li.textContent = pt[0]; li.setAttribute('aria-current', 'page');
      }
      ol.appendChild(li);
    });
    nav.appendChild(ol);
    host.parentNode.insertBefore(nav, host);
  }

  /* -------------------------------------------------------------- hero */
  function hero() {
    var title = doc.querySelector('.x-section-collection-banner .collection-title');
    if (!title || title.getAttribute('data-mtk')) return;
    title.setAttribute('data-mtk', '1');

    var heading = title.querySelector('h1, h2, h3');
    if (D.eyebrow && heading) {
      var eb = doc.createElement('p');
      eb.className = 'mtk-eyebrow';
      eb.textContent = D.eyebrow;
      heading.parentNode.insertBefore(eb, heading);
    }
    if (D.desc) {
      var p = doc.createElement('p');
      p.className = 'mtk-desc';
      p.textContent = D.desc;
      title.appendChild(p);
    }
    if (D.meta && D.meta.length) {
      var dl = doc.createElement('dl');
      dl.className = 'mtk-meta';
      D.meta.forEach(function (pair) {
        var d = doc.createElement('div');
        var k = doc.createElement('dt'); k.className = 'mtk-k'; k.textContent = pair[0];
        var v = doc.createElement('dd'); v.className = 'mtk-v'; v.textContent = pair[1];
        v.style.margin = '0';
        d.appendChild(k); d.appendChild(v); dl.appendChild(d);
      });
      title.appendChild(dl);
    }
  }

  /* ------------------------------------------------- sibling rail + chips */
  function insertAfterBanner(el) {
    var banner = doc.querySelector('.x-section-collection-banner');
    if (!banner) return false;
    banner.parentNode.insertBefore(el, banner.nextSibling);
    return true;
  }

  function rail() {
    if (!D.siblings || !D.siblings.length || doc.querySelector('.mtk-rail-wrap')) return;
    var wrap = doc.createElement('div');
    wrap.className = 'mtk-rail-wrap';
    var nav = doc.createElement('nav');
    nav.className = 'mtk-rail';
    nav.setAttribute('aria-label', 'Collections');
    D.siblings.forEach(function (s) {
      var a = doc.createElement('a');
      a.href = s.url;
      a.textContent = s.title;
      if (s.current) a.setAttribute('aria-current', 'page');
      nav.appendChild(a);
    });
    wrap.appendChild(nav);
    insertAfterBanner(wrap);
  }

  function chips() {
    if (!D.chips || !D.chips.length || doc.querySelector('.mtk-chips-wrap')) return;
    var wrap = doc.createElement('div');
    wrap.className = 'mtk-chips-wrap';
    var nav = doc.createElement('nav');
    nav.className = 'mtk-chips';
    nav.setAttribute('aria-label', D.chipsLabel || 'Style');
    D.chips.forEach(function (c) {
      var a = doc.createElement('a');
      a.href = c.url;
      if (c.active) a.setAttribute('aria-current', 'true');
      a.appendChild(doc.createTextNode(c.label));
      if (c.count) {
        var n = doc.createElement('span');
        n.className = 'mtk-n';
        n.textContent = c.count;
        a.appendChild(n);
      }
      nav.appendChild(a);
    });
    wrap.appendChild(nav);
    var railWrap = doc.querySelector('.mtk-rail-wrap');
    if (railWrap) railWrap.parentNode.insertBefore(wrap, railWrap.nextSibling);
    else insertAfterBanner(wrap);
  }

  /* ------------------------------------------- promotion tile out of slot 1 */
  /* The "Enjoy Free Shipping Across India" tile occupies the most valuable
   * position in the grid and is illustrated with a necklace. Move it to the
   * end rather than delete it - the merchandiser still gets the message. */
  function promo() {
    var grid = gridEl();
    if (!grid) return;
    var items = grid.children, moved = [];
    for (var i = 0; i < items.length; i++) {
      var el = items[i];
      if (!el.querySelector) continue;
      if (el.querySelector('.card-product')) continue;
      if (el.getAttribute('data-mtk-promo')) continue;
      el.setAttribute('data-mtk-promo', '1');
      moved.push(el);
    }
    moved.forEach(function (el) { el.parentNode.appendChild(el); });
  }

  /* --------------------------------------------------------- card state */
  /* The theme puts a JSON payload on each card link in x-labels-data. It
   * carries the real availability and inventory for the product, so both the
   * badge and the ordering come from the same source the theme itself uses. */
  function cardData(card) {
    var link = card.querySelector('[x-labels-data]');
    if (!link) return null;
    try {
      var arr = JSON.parse(link.getAttribute('x-labels-data'));
      return arr && arr[0] ? arr[0] : null;
    } catch (e) { return null; }
  }

  function decorate() {
    var g = gridEl(); if (!g) return;
    var cards = g.querySelectorAll('.card-product');
    var allSingle = true, any = false;
    var parsed = [];

    for (var i = 0; i < cards.length; i++) {
      var d = cardData(cards[i]);
      parsed.push(d);
      if (!d) continue;
      any = true;
      if (d.available && d.qty > 1) allSingle = false;
    }

    for (var j = 0; j < cards.length; j++) {
      var card = cards[j], data = parsed[j];
      if (!data || card.getAttribute('data-mtk-badge')) continue;
      card.setAttribute('data-mtk-badge', '1');

      var label = null, cls = '';
      if (!data.available) { label = 'Sold out'; cls = ' mtk-badge--soldout'; }
      else if (any && allSingle) { label = 'One of one'; cls = ' mtk-badge--one'; }
      else if (data.qty === 1) { label = 'Last one'; cls = ' mtk-badge--soldout'; }

      if (label) {
        var b = doc.createElement('span');
        b.className = 'mtk-badge' + cls;
        b.textContent = label;
        var media = card.querySelector('.link-product-variant') || card;
        (media.parentNode || card).insertBefore(b, media);
      }
      if (!data.available) card.classList.add('mtk-soldout');

      /* P3 fix: the theme leaves a visually hidden "Sold out" string inside
       * cards that are in stock. It is invisible but screen readers announce
       * it. Take those out of the accessibility tree, and only those. */
      if (data.available) hideFalseSoldOut(card);
    }
  }

  function hideFalseSoldOut(card) {
    var needle = (D.soldOutText || 'sold out').toLowerCase();
    var all = card.querySelectorAll('span, div, p');
    for (var k = 0; k < all.length; k++) {
      var el = all[k];
      if (el.children.length) continue;
      if ((el.textContent || '').trim().toLowerCase() !== needle) continue;
      var r = el.getBoundingClientRect();
      if (r.width === 0 || r.height === 0 || el.offsetParent === null) {
        el.setAttribute('aria-hidden', 'true');
        el.setAttribute('data-mtk-muted', '1');
      }
    }
  }

  /* --------------------------------------------- in-stock-first ordering */
  /* Shopify cannot sort a collection by availability natively, and Liquid only
   * ever sees one page at a time. This reorders whatever is currently in the
   * grid, which is the complete collection for NECKLACES (20), CUFFS (8) and
   * CHARMS (13) - exactly the three that have sold-out stock - and the loaded
   * set everywhere else. Stable: relative order within each group is kept. */
  function reorder() {
    var grid = gridEl();
    if (!grid) return;
    var items = grid.querySelectorAll('.grid-item');
    if (!items.length) return;
    var out = [];
    for (var i = 0; i < items.length; i++) {
      var card = items[i].querySelector('.card-product');
      var d = card ? cardData(card) : null;
      out.push({ el: items[i], sold: d ? !d.available : false, i: i });
    }
    var needs = false;
    for (var j = 1; j < out.length; j++) { if (out[j - 1].sold && !out[j].sold) { needs = true; break; } }
    if (!needs) return;
    out.sort(function (a, b) { return (a.sold - b.sold) || (a.i - b.i); });
    var parent = out[0].el.parentNode;
    var frag = doc.createDocumentFragment();
    out.forEach(function (o) { frag.appendChild(o.el); });
    parent.appendChild(frag);
  }

  /* ------------------------------------------------------ loading state */
  function loading() {
    var grid = gridEl();
    if (!grid) return;
    doc.addEventListener('change', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('form[id*="Facet"], .x-section-product-grid form')) {
        grid.classList.add('mtk-loading');
        window.setTimeout(function () { grid.classList.remove('mtk-loading'); }, 6000);
      }
    }, true);
  }

  /* ------------------------------------------------------------- wiring */
  function run() {
    safe(crumb); safe(hero); safe(rail); safe(chips); safe(promo); safe(decorate); safe(reorder);
  }

  function watch() {
    var grid = gridEl();
    if (!grid || !window.MutationObserver) return;
    var t = null;
    new MutationObserver(function () {
      grid.classList.remove('mtk-loading');
      window.clearTimeout(t);
      t = window.setTimeout(function () { safe(decorate); safe(reorder); }, 60);
    }).observe(grid, { childList: true, subtree: true });
  }

  function boot() { run(); safe(loading); safe(watch); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.addEventListener('load', function () { window.setTimeout(run, 400); });
})();
